import { supabaseClient } from "../config/supabase-clients";

export const GetAlerts = async () => {
    const { data: alert, error } = await supabaseClient.from('alerts').select('*')
    if (error) {
        return error;
    }
    return alert;
}